import { Chip } from '@mui/material';

const IncludedChip = () => (
  <Chip
    label="Included"
    size="small"
    sx={{
      position: 'absolute',
      fontSize: '12px',
      height: '20px',
      top: -10,
      right: { xxs: -12, xs: -10 },
      zIndex: 10,
      color: '#fff',
      backgroundColor: '#52b5f1',
      fontWeight: 500,
      padding: '13px 25px',
    }}
  />
);

export default IncludedChip;